// Warehouse Repository - Repository Pattern
import apiService from '../api.service';

class WarehouseRepository {
  // Get all warehouses
  async getAll() {
    return apiService.get('/warehouses');
  }

  // Get single warehouse
  async getById(id) {
    return apiService.get(`/warehouses/${id}`);
  }

  // Create warehouse
  async create(data) {
    return apiService.post('/warehouses', data);
  }

  // Update warehouse
  async update(id, data) {
    return apiService.patch(`/warehouses/${id}`, data);
  }

  // Delete warehouse
  async delete(id) {
    return apiService.delete(`/warehouses/${id}`);
  }
}

export default new WarehouseRepository();
